// // // shared/Editor/schemaUtils.js
// // //
// // // A schema block lives inside the blog HTML as a visible card:
// // //   <div data-schema-block="1" data-schema="<encoded json>"> ... </div>
// // // The JSON in `data-schema` is the source of truth. The <pre> inside is only
// // // a readable preview. The card has no nested <div>, so the regex below is safe.

// // const BLOCK_RE = /<div\b[^>]*data-schema-block[^>]*>[\s\S]*?<\/div>/gi;

// // const esc = (s = "") =>
// //     String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

// // /** Build the HTML card for one schema object (used by the editor). */
// // export function buildSchemaBlock(obj) {
// //     const pretty = JSON.stringify(obj, null, 2);
// //     const enc = encodeURIComponent(JSON.stringify(obj));
// //     const type = esc(Array.isArray(obj) ? "Multiple" : obj?.["@type"] || "Schema");
// //     return (
// //         `<div class="schema-block" data-schema-block="1" data-schema="${enc}" contenteditable="false" ` +
// //         `style="border:1px dashed #6b46c1;background:#f7f3ff;border-radius:6px;padding:10px 12px;margin:12px 0;cursor:pointer;">` +
// //         `<span style="display:block;font:600 12px/1.4 sans-serif;color:#6b46c1;margin-bottom:6px;">` +
// //         `Schema: ${type} (click to edit)</span>` +
// //         `<pre style="margin:0;white-space:pre-wrap;word-break:break-word;font:12px/1.5 monospace;color:#333;">${esc(pretty)}</pre>` +
// //         `</div>`
// //     );
// // }

// // /** Read the schema object out of one card element (browser only). */
// // export function readSchemaFromElement(el) {
// //     try {
// //         return JSON.parse(decodeURIComponent(el.getAttribute("data-schema") || ""));
// //     } catch {
// //         return null;
// //     }
// // }

// // /** All schema objects found in an HTML string (works in browser and on the server). */
// // export function extractSchemas(html = "") {
// //     const out = [];
// //     (html.match(BLOCK_RE) || []).forEach((block) => {
// //         const m = block.match(/data-schema="([^"]*)"/);
// //         if (!m) return;
// //         try {
// //             out.push(JSON.parse(decodeURIComponent(m[1])));
// //         } catch {
// //             /* ignore broken block */
// //         }
// //     });
// //     return out;
// // }

// // /** Remove the cards so readers never see them on the public page. */
// // export function stripSchemaBlocks(html = "") {
// //     return html.replace(BLOCK_RE, "");
// // }

// // /** JSON string that is safe to place inside <script type="application/ld+json"> */
// // export function safeJsonLd(obj) {
// //     return JSON.stringify(obj).replace(/</g, "\\u003c");
// // }

// // // ---------------------------------------------------------------------------
// // // Templates used by the dialog (browser only)
// // // ---------------------------------------------------------------------------

// // const clean = (t = "") => t.replace(/\s+/g, " ").trim();
// // const CTX = "https://schema.org";

// // const tableRows = (table) =>
// //     Array.from(table.rows).map((r) =>
// //         Array.from(r.cells).map((c) => clean(c.textContent)),
// //     );

// // export const SCHEMA_TYPES = [
// //     { value: "table", label: "Table (nearest table)" },
// //     { value: "product", label: "Product specs (from nearest table)" },
// //     { value: "image", label: "Image (nearest image)" },
// //     { value: "blog", label: "Blog post / Article" },
// //     { value: "faq", label: "FAQ" },
// //     { value: "custom", label: "Custom JSON" },
// // ];

// // export function buildTemplate(type, ctx) {
// //     switch (type) {
// //         case "table": {
// //             const rows = ctx.table ? tableRows(ctx.table) : [];
// //             return {
// //                 "@context": CTX,
// //                 "@type": "Table",
// //                 name: ctx.tableName || "Table title",
// //                 about: "What this table compares",
// //                 description: rows[0] ? "Columns: " + rows[0].join(", ") : "",
// //             };
// //         }
// //         case "product": {
// //             const rows = ctx.table ? tableRows(ctx.table) : [];
// //             const head = rows[0] || [];
// //             const props = [];
// //             rows.slice(1).forEach((row) => {
// //                 row.slice(1).forEach((val, j) => {
// //                     const col = head[j + 1];
// //                     props.push({
// //                         "@type": "PropertyValue",
// //                         name: col ? `${row[0]} (${col})` : row[0],
// //                         value: val,
// //                     });
// //                 });
// //             });
// //             return {
// //                 "@context": CTX,
// //                 "@type": "Product",
// //                 name: "Product name",
// //                 brand: { "@type": "Brand", name: "Brand name" },
// //                 additionalProperty: props,
// //             };
// //         }
// //         case "image":
// //             return {
// //                 "@context": CTX,
// //                 "@type": "ImageObject",
// //                 contentUrl: ctx.img?.src || "https://example.com/image.jpg",
// //                 name: ctx.img?.alt || "Image title",
// //                 caption: ctx.img?.alt || "Image caption",
// //             };
// //         case "blog":
// //             return {
// //                 "@context": CTX,
// //                 "@type": "BlogPosting",
// //                 headline: ctx.headline || "Blog title",
// //                 description: (ctx.firstPara || "").slice(0, 160),
// //                 image: ctx.firstImg || undefined,
// //                 datePublished: new Date().toISOString(),
// //                 author: { "@type": "Organization", name: "Your brand" },
// //             };
// //         case "faq":
// //             return {
// //                 "@context": CTX,
// //                 "@type": "FAQPage",
// //                 mainEntity: [
// //                     {
// //                         "@type": "Question",
// //                         name: "Your question?",
// //                         acceptedAnswer: { "@type": "Answer", text: "Your answer." },
// //                     },
// //                 ],
// //             };
// //         default:
// //             return { "@context": CTX, "@type": "" };
// //     }
// // }

// // /** Look at the editor DOM around the cursor so templates can pre-fill themselves. */
// // export function captureContext(editor) {
// //     const root = editor.editor;
// //     const cur = editor.s.current();
// //     const inRoot = cur && root.contains(cur) && cur !== root;

// //     // top-level block that holds the cursor: the schema goes right below it
// //     let anchor = null;
// //     if (inRoot) {
// //         anchor = cur;
// //         while (anchor.parentNode && anchor.parentNode !== root) anchor = anchor.parentNode;
// //     }

// //     const nearest = (selector) => {
// //         const all = Array.from(root.querySelectorAll(selector));
// //         if (!all.length) return null;
// //         if (inRoot) {
// //             const base = cur.nodeType === 1 ? cur : cur.parentElement;
// //             const hit = base && base.closest(selector);
// //             if (hit && root.contains(hit)) return hit;
// //             let prev = null;
// //             all.forEach((el) => {
// //                 if (el.compareDocumentPosition(cur) & Node.DOCUMENT_POSITION_FOLLOWING) prev = el;
// //             });
// //             return prev || all[0];
// //         }
// //         return all[all.length - 1];
// //     };

// //     const table = nearest("table");
// //     let tableName = "";
// //     if (table) {
// //         root.querySelectorAll("h1,h2,h3,h4,h5,h6").forEach((h) => {
// //             if (h.compareDocumentPosition(table) & Node.DOCUMENT_POSITION_FOLLOWING) {
// //                 tableName = clean(h.textContent);
// //             }
// //         });
// //     }

// //     return {
// //         anchor,
// //         table,
// //         tableName,
// //         img: nearest("img"),
// //         headline: clean(root.querySelector("h1,h2")?.textContent || ""),
// //         firstPara: clean(root.querySelector("p")?.textContent || ""),
// //         firstImg: root.querySelector("img")?.src || "",
// //     };
// // }

// "use client";

// // Put this file next to WBlogDetails.jsx. No other file is needed.
// // It renders the blog HTML, and in the place where a schema was added it
// // renders the schema's JSON data (image, specs table, FAQ, or key/value list).
// // It also outputs the same JSON as <script type="application/ld+json"> for SEO.

// import React from "react";

// const BLOCK = "<div\\b[^>]*data-schema-block[^>]*>[\\s\\S]*?<\\/div>";

// // split the HTML into [{html}] and [{schema}] parts, in order
// function parse(html = "") {
//     const parts = [];
//     const re = new RegExp(BLOCK, "gi");
//     let last = 0;
//     let m;
//     while ((m = re.exec(html))) {
//         if (m.index > last) parts.push({ html: html.slice(last, m.index) });
//         try {
//             const enc = m[0].match(/data-schema="([^"]*)"/)[1];
//             parts.push({ schema: JSON.parse(decodeURIComponent(enc)) });
//         } catch (e) { }
//         last = m.index + m[0].length;
//     }
//     if (last < html.length) parts.push({ html: html.slice(last) });
//     return parts;
// }

// const cell = { border: "1px solid #555", padding: "8px 12px", textAlign: "left" };

// // a schema can be one object, an array of objects, or { "@graph": [...] }
// function Schema({ s }) {
//     const items = Array.isArray(s)
//         ? s
//         : Array.isArray(s?.["@graph"])
//             ? s["@graph"]
//             : [s];
//     return items.map((item, i) => <SchemaItem key={i} s={item} />);
// }

// function SchemaItem({ s }) {
//     if (!s || typeof s !== "object") return null;
//     const type = [].concat(s["@type"] || "")[0];

//     // Image -> show the image
//     if (type === "ImageObject") {
//         const src = s.contentUrl || s.url;
//         if (!src) return null;
//         return (
//             <figure style={{ margin: "24px 0" }}>
//                 <img
//                     src={src}
//                     alt={s.name || ""}
//                     style={{ width: "100%", height: "auto", borderRadius: 8 }}
//                     onError={(e) => (e.currentTarget.style.display = "none")}
//                 />
//                 {(s.caption || s.description) && (
//                     <figcaption style={{ textAlign: "center", marginTop: 8 }}>
//                         {s.caption && <strong style={{ display: "block" }}>{s.caption}</strong>}
//                         {s.description && (
//                             <span style={{ display: "block", opacity: 0.7 }}>{s.description}</span>
//                         )}
//                     </figcaption>
//                 )}
//             </figure>
//         );
//     }

//     // Product -> specs table
//     if (type === "Product") {
//         const rows = [].concat(s.additionalProperty || []);
//         return (
//             <div style={{ margin: "24px 0", overflowX: "auto" }}>
//                 {s.name && <h3>{s.name}</h3>}
//                 <table style={{ borderCollapse: "collapse", width: "100%" }}>
//                     <tbody>
//                         {rows.map((r, i) => (
//                             <tr key={i}>
//                                 <td style={{ ...cell, fontWeight: 600 }}>{r.name}</td>
//                                 <td style={cell}>{String(r.value)}</td>
//                             </tr>
//                         ))}
//                     </tbody>
//                 </table>
//             </div>
//         );
//     }

//     // FAQ -> questions and answers
//     if (type === "FAQPage") {
//         return (
//             <div style={{ margin: "24px 0" }}>
//                 {[].concat(s.mainEntity || []).map((q, i) => (
//                     <div key={i} style={{ marginBottom: 14 }}>
//                         <h4 style={{ margin: "0 0 4px" }}>{q.name}</h4>
//                         <p style={{ margin: 0, opacity: 0.8 }}>{q.acceptedAnswer?.text}</p>
//                     </div>
//                 ))}
//             </div>
//         );
//     }

//     // Blog post / article -> SEO only, nothing to show
//     if (type === "BlogPosting" || type === "Article") return null;

//     // Anything else (Table, custom...) -> simple key / value list of the JSON
//     const rows = Object.entries(s).filter(([k]) => !k.startsWith("@"));
//     if (!rows.length) return null;
//     return (
//         <div style={{ margin: "24px 0", overflowX: "auto" }}>
//             <table style={{ borderCollapse: "collapse", width: "100%" }}>
//                 <tbody>
//                     {rows.map(([k, v]) => (
//                         <tr key={k}>
//                             <td style={{ ...cell, fontWeight: 600 }}>{k}</td>
//                             <td style={cell}>
//                                 {typeof v === "object" ? JSON.stringify(v) : String(v)}
//                             </td>
//                         </tr>
//                     ))}
//                 </tbody>
//             </table>
//         </div>
//     );
// }

// export default function SchemaContent({ html = "", className, style }) {
//     const parts = parse(html);
//     return (
//         <div className={className} style={style}>
//             {parts.map((p, i) =>
//                 p.schema ? (
//                     <React.Fragment key={i}>
//                         <Schema s={p.schema} />
//                         <script
//                             type="application/ld+json"
//                             dangerouslySetInnerHTML={{
//                                 __html: JSON.stringify(p.schema).replace(/</g, "\\u003c"),
//                             }}
//                         />
//                     </React.Fragment>
//                 ) : (
//                     <div key={i} dangerouslySetInnerHTML={{ __html: p.html }} />
//                 )
//             )}
//         </div>
//     );
// }

// shared/Editor/schemaUtils.js
//
// A schema block lives inside the blog HTML as a visible card:
//   <div data-schema-block="1" data-schema="<encoded json>"> ... </div>
// The JSON in `data-schema` is the source of truth. The <pre> inside is only
// a readable preview. The card has no nested <div>, so the regex below is safe.

const BLOCK_RE = /<div\b[^>]*data-schema-block[^>]*>[\s\S]*?<\/div>/gi;

const esc = (s = "") =>
    String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

/** Build the HTML card for one schema object (used by the editor). */
export function buildSchemaBlock(obj) {
    const pretty = JSON.stringify(obj, null, 2);
    const enc = encodeURIComponent(JSON.stringify(obj));
    const type = esc(Array.isArray(obj) ? "Multiple" : obj?.["@type"] || "Schema");
    return (
        `<div class="schema-block" data-schema-block="1" data-schema="${enc}" contenteditable="false" ` +
        `style="border:1px dashed #6b46c1;background:#f7f3ff;border-radius:6px;padding:10px 12px;margin:12px 0;cursor:pointer;">` +
        `<span style="display:block;font:600 12px/1.4 sans-serif;color:#6b46c1;margin-bottom:6px;">` +
        `Schema: ${type} (click to edit)</span>` +
        `<pre style="margin:0;white-space:pre-wrap;word-break:break-word;font:12px/1.5 monospace;color:#333;">${esc(pretty)}</pre>` +
        `</div>`
    );
}

/** Read the schema object out of one card element (browser only). */
export function readSchemaFromElement(el) {
    try {
        return JSON.parse(decodeURIComponent(el.getAttribute("data-schema") || ""));
    } catch {
        return null;
    }
}

/** All schema objects found in an HTML string (works in browser and on the server). */
export function extractSchemas(html = "") {
    const out = [];
    (html.match(BLOCK_RE) || []).forEach((block) => {
        const m = block.match(/data-schema="([^"]*)"/);
        if (!m) return;
        try {
            out.push(JSON.parse(decodeURIComponent(m[1])));
        } catch {
            /* ignore broken block */
        }
    });
    return out;
}

/** Remove the cards so readers never see them on the public page. */
export function stripSchemaBlocks(html = "") {
    return html.replace(BLOCK_RE, "");
}

/** JSON string that is safe to place inside <script type="application/ld+json"> */
export function safeJsonLd(obj) {
    return JSON.stringify(obj).replace(/</g, "\\u003c");
}

// ---------------------------------------------------------------------------
// Templates used by the dialog (browser only)
// ---------------------------------------------------------------------------

const clean = (t = "") => t.replace(/\s+/g, " ").trim();
const CTX = "https://schema.org";

const tableRows = (table) =>
    Array.from(table.rows).map((r) =>
        Array.from(r.cells).map((c) => clean(c.textContent)),
    );

export const SCHEMA_TYPES = [
    { value: "table", label: "Table (nearest table)" },
    { value: "product", label: "Product specs (from nearest table)" },
    { value: "image", label: "Image (nearest image)" },
    { value: "blog", label: "Blog post / Article" },
    { value: "faq", label: "FAQ" },
    { value: "custom", label: "Custom JSON" },
];

export function buildTemplate(type, ctx) {
    switch (type) {
        case "table": {
            const rows = ctx.table ? tableRows(ctx.table) : [];
            return {
                "@context": CTX,
                "@type": "Table",
                name: ctx.tableName || "Table title",
                about: "What this table compares",
                description: rows[0] ? "Columns: " + rows[0].join(", ") : "",
            };
        }
        case "product": {
            const rows = ctx.table ? tableRows(ctx.table) : [];
            const head = rows[0] || [];
            const props = [];
            rows.slice(1).forEach((row) => {
                row.slice(1).forEach((val, j) => {
                    const col = head[j + 1];
                    props.push({
                        "@type": "PropertyValue",
                        name: col ? `${row[0]} (${col})` : row[0],
                        value: val,
                    });
                });
            });
            return {
                "@context": CTX,
                "@type": "Product",
                name: "Product name",
                brand: { "@type": "Brand", name: "Brand name" },
                additionalProperty: props,
            };
        }
        case "image":
            return {
                "@context": CTX,
                "@type": "ImageObject",
                contentUrl: ctx.img?.src || "https://example.com/image.jpg",
                name: ctx.img?.alt || "Image title",
                caption: ctx.img?.alt || "Image caption",
            };
        case "blog":
            return {
                "@context": CTX,
                "@type": "BlogPosting",
                headline: ctx.headline || "Blog title",
                description: (ctx.firstPara || "").slice(0, 160),
                image: ctx.firstImg || undefined,
                datePublished: new Date().toISOString(),
                author: { "@type": "Organization", name: "Your brand" },
            };
        case "faq":
            return {
                "@context": CTX,
                "@type": "FAQPage",
                mainEntity: [
                    {
                        "@type": "Question",
                        name: "Your question?",
                        acceptedAnswer: { "@type": "Answer", text: "Your answer." },
                    },
                ],
            };
        default:
            return { "@context": CTX, "@type": "" };
    }
}

/** Look at the editor DOM around the cursor so templates can pre-fill themselves. */
export function captureContext(editor) {
    const root = editor.editor;
    const cur = editor.s.current();
    const inRoot = cur && root.contains(cur) && cur !== root;

    // top-level block that holds the cursor: the schema goes right below it
    let anchor = null;
    if (inRoot) {
        anchor = cur;
        while (anchor.parentNode && anchor.parentNode !== root) anchor = anchor.parentNode;
    }

    const nearest = (selector) => {
        const all = Array.from(root.querySelectorAll(selector));
        if (!all.length) return null;
        if (inRoot) {
            const base = cur.nodeType === 1 ? cur : cur.parentElement;
            const hit = base && base.closest(selector);
            if (hit && root.contains(hit)) return hit;
            let prev = null;
            all.forEach((el) => {
                if (el.compareDocumentPosition(cur) & Node.DOCUMENT_POSITION_FOLLOWING) prev = el;
            });
            return prev || all[0];
        }
        return all[all.length - 1];
    };

    const table = nearest("table");
    let tableName = "";
    if (table) {
        root.querySelectorAll("h1,h2,h3,h4,h5,h6").forEach((h) => {
            if (h.compareDocumentPosition(table) & Node.DOCUMENT_POSITION_FOLLOWING) {
                tableName = clean(h.textContent);
            }
        });
    }

    return {
        anchor,
        table,
        tableName,
        img: nearest("img"),
        headline: clean(root.querySelector("h1,h2")?.textContent || ""),
        firstPara: clean(root.querySelector("p")?.textContent || ""),
        firstImg: root.querySelector("img")?.src || "",
    };
}